export default __webpack_public_path__ + "static/media/gallery_06.75b62659.jpg";